import {
  SET_LMS_CONFIG,
  SET_LMS_LOADING,
  SET_LMS_ERROR
} from '../actions/lms.actions';

const initialState = {
  config: null,   // { enabled, portal_url, has_token, configured_at }
  loading: false,
  error: null
};

const lmsReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LMS_CONFIG:
      return { ...state, config: action.payload, error: null };
    case SET_LMS_LOADING:
      return { ...state, loading: action.payload };
    case SET_LMS_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default lmsReducer;
